<template>
<div>
  <div class="paper_item">
    <div class="paper_title"> Controllable Swarm Animation using Deep Reinforcement Learning with a Rule-based Action Generator.</div>
    <div class="paper_desc">
      Zong-Sheng Wang.<br /> 
      Doctoral Dissertation. (2021) 
      [<a href="https://doi.org/10.1109/ACCESS.2022.3172492">doi</a>]
    </div> 
  </div>
  <div class="paper_item">
    <div class="paper_title"> Efficient Chaotic Imperialist Competitive Algorithm with Dropout Strategy for Global Optimization.</div>
    <div class="paper_desc">
      Zong-Sheng Wang, Jung Lee, Chang Geun Song, Sun-Jeong Kim.<br /> 
      Symmetry 2020, 12(4), 635.
      [<a href="https://doi.org/10.3390/sym12040635">doi</a>]
    </div> 
  </div>
  <div class="paper_item">
    <div class="paper_title"> Data-driven point sampling with blue-noise properties for triangular meshes.</div>
    <div class="paper_desc">
      Zong-Sheng Wang, Jung Lee, Chang Geun Song, Sun-Jeong Kim.<br /> 
      In Proceedings of the 2020 3rd International Conference on Computer Science and Software Engineering (CSSE 2020). 
      [<a href="https://doi.org/10.1145/3403746.3403908">doi</a>]
    </div> 
  </div>
  <div class="paper_item">
    <div class="paper_title"> Unrealistic map based navigation system for pedestrian.</div>
    <div class="paper_desc">
      Zong-Sheng Wang, Seon-Woo Lee, Chang Geun Song.<br /> 
      Life Science Journal. 11. 73-78. (2014) 
      [<a href="https://doi.org/10.7537/marslsj1107s14.12">doi</a>]
    </div> 
  </div>
  <div class="paper_item">
    <div class="paper_title"> GP-GPU based Smoothed Particle Hydrodynamic Fluid Simulation.</div>
    <div class="paper_desc">
      Zong-Sheng Wang.<br /> 
      Master Thesis. (2013)
    </div> 
  </div>
  <div class="paper_item">
    <div class="paper_title"> Using a Smart Phone as input device for PC.</div>
    <div class="paper_desc">
      Zong-Sheng Wang, Ji-Hoon Choi, Youngwoong Ko, Chang Geun Song.<br /> 
      The 2012 international Workshop on Advanced Image Technology (IWAIT 2012).
    </div> 
  </div>
</div>
</template>

<script>

export default {
  name: 'Publications'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paper_item{
    font-family: 'Roboto', Geneva, Verdana, sans-serif;
    margin-bottom: 20px;
}
.paper_item a, a:active, a:visited{
    border-bottom: dashed 1px #ccc;
    text-decoration: none;
    color: #555;
}
.paper_title{
    font-size: 15px;
    font-weight: bold;
    color: #000;
}
.paper_desc{
    font-size: 14px;
    color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/Publications.vue